import React from "react";
import OverrideToastContext from "../../context/overrideToastContext";

export const OverrideToastConsumer = ({ children }) => {
  return (
    <OverrideToastContext.Consumer>
      {context => children(context)}
    </OverrideToastContext.Consumer>
  );
};
